var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('FreeSequHealth'),_c('TrustEconomy'),_c('Products'),_c('DownloadBrochure')],1)}
var staticRenderFns = []

export { render, staticRenderFns }